import { render, staticRenderFns } from "./DriveBuzzConfiguration.vue?vue&type=template&id=0e3d9070&scoped=true"
import script from "./DriveBuzzConfiguration.vue?vue&type=script&lang=ts"
export * from "./DriveBuzzConfiguration.vue?vue&type=script&lang=ts"
import style0 from "./DriveBuzzConfiguration.vue?vue&type=style&index=0&id=0e3d9070&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3d9070",
  null
  
)

export default component.exports